import React from "react";

import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";

const ErrorFallback: React.FC = () => {
  return (
    <Stack justifyContent="center" alignItems="center" height="100%" padding={2}>
      <Typography variant="body1" fontWeight={600} textAlign="center" marginBottom={1}>
        Something went wrong.
      </Typography>
      <Typography variant="body1" textAlign="center">
        Try refreshing the page. If the issue persists, contact your Marketing Science Partner.
      </Typography>
    </Stack>
  );
};

export default ErrorFallback;
